import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { UrlMetadata } from 'api';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    paddingTop: 12,
  },
});

interface IProps {
  title: UrlMetadata['title'];
}

const Title: FC<IProps> = ({ title }) => {
  const classes = useStyles();

  return (
    <Typography gutterBottom color="textPrimary" variant="h6" className={classes.root}>
      {title}
    </Typography>
  );
};

export default Title;
